import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import { componentiApi, tipologieBoxApi } from '@/api/box'
import { getProdotti } from '@/api/products'

export function useInventoryCatalogSearch(tipoItem, searchItem) {
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const normalizedSearch = searchItem.trim()

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(normalizedSearch), 300)
    return () => clearTimeout(timer)
  }, [normalizedSearch])

  const isProdotto = tipoItem === 'prodotto'
  const isBox = tipoItem === 'box'
  const query = useQuery({
    queryKey: [
      isProdotto ? 'prodotti' : (isBox ? 'tipologie-box' : 'componenti-scatola'),
      'ricerca-magazzino',
      debouncedSearch,
    ],
    queryFn: () => {
      if (isProdotto) return getProdotti({ stato: 'attivo', search: debouncedSearch })
      if (isBox) return tipologieBoxApi.getAll({ attivo: true, search: debouncedSearch })
      return componentiApi.getAll({ attivo: true, search: debouncedSearch })
    },
    enabled: debouncedSearch.length > 0,
  })

  const payload = query.data?.data
  const items = Array.isArray(payload) ? payload : (payload?.results || [])

  return {
    items,
    isSearching: normalizedSearch !== debouncedSearch || query.isFetching,
  }
}
